import React from "react";

import { IconCloseCircleFilled } from "~/components/icon";
import { Tooltip } from "~/components/tooltip";
import { TooltipContent } from "~/components/tooltip/content";
import { TooltipTrigger } from "~/components/tooltip/trigger";

export const CellError: React.FC<{
	message: string;
}> = ({ message }) => (
	<Tooltip>
		<TooltipContent>{message}</TooltipContent>
		<TooltipTrigger>
			<IconCloseCircleFilled className="cursor-help text-red-500" />
		</TooltipTrigger>
	</Tooltip>
);
